import * as React from 'react';

//hook
import { useState,useEffect } from 'react';
import { UserConsumer } from '../hooks/context/UserContext';

//type
import { loginReqType } from '../api/login/type/LoginType';

//api
import { PostLoginApi } from '../api/login/PostLoginApi';
import { useApi } from '../hooks/useApi';

//mui
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import TextField from '@mui/material/TextField';
import CircularProgress from '@mui/material/CircularProgress';

//mui icon
import IconButton from "@mui/material/IconButton";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";


// Country Piker  Library
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";

//translate
import { useTranslation } from 'react-i18next';
import i18n from '../translate/i18n';

//formik and yap
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';

//react router dom
import { useNavigate } from 'react-router-dom';

//image
import login_logo from '../assets/login/login_logo.png'
import apple from "../assets/login/apple.png"
import google from "../assets/login/google.png"

//device token
import {requestNotificationPermission} from "../firebase/notifgicationFireBase";


const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

interface loginProps {
  openLogin: boolean,
  setOpenLogin: (open: boolean) =>void
  setOpenSignup: (open: boolean) =>void
  setOpenForgetPassword: (open: boolean) =>void
}


const Login = ({openLogin, setOpenLogin, setOpenSignup, setOpenForgetPassword} : loginProps) => {
  const { t } = useTranslation();
  const [showPass, setShowPass] = useState<boolean>(false)
  const navigate = useNavigate();
  let {setUserData} = UserConsumer()


  const loginSchema = Yup.object().shape({
    phone: Yup.string()
      //test(name, message, testFunction)
      .test(
        "len",t("phone_lenght"),
        (value) => {
          if (!value) return false;
          const numberWithoutCode = value.slice(4);
          return numberWithoutCode.length == 9 && !numberWithoutCode.startsWith("0") ;
        }
      ).required(t("phone_required")),
      password: Yup.string().min(6, t("password_min")).required(t("password_required")),
  });
  const {
    loading: loginLoading,
    error: loginError,
    HandlerApi: loginApi
  } = useApi(PostLoginApi, "POST");

  // start functions

  const handleClose = () => {
    setOpenLogin(false);
    setShowPass(false)
  };
  const handleSubmit = async (values: loginReqType)=> {
    const deviceToken = await requestNotificationPermission().then((token) => token);
      const payload = {
      ...values,
      device_token: deviceToken,
      device_type: "web",
    };
    const result = await loginApi(payload);
    localStorage.setItem("token", result.data.token);
    setUserData(result.data)
    console.log('login successful:');
    navigate("/")
    handleClose();
  }
  const handleOpenSignup = ()=> {
    setOpenSignup(true)
    setOpenLogin(false)
    setShowPass(false)
  }

  const handleForgetPassword = ()=> {
    setOpenForgetPassword(true)
    setOpenLogin(false)
  }
  // end functions

  return (
    <div>
      <Dialog 
      open={openLogin}
      onClose={handleClose}
      slots={{
        transition: Transition,
      }}
      disableRestoreFocus
      maxWidth="md"
      fullWidth 
      >
          <DialogTitle className='flex gap-3'>
            <img className='w-[30px] h-[30px]' src={login_logo} alt='no=photo'/>
            <p>{t("gettak")}</p>
          </DialogTitle>
          <div className='flex justify-between max-sm:flex-col pb-5'>
            <div className='w-full'>
              <DialogTitle>
                <p className="whitespace-pre-line">{t("welcome_back_ready_to_hit_the_road")}</p>
              </DialogTitle>
              <DialogContent>
              <Formik
              initialValues={{phone: '' , password: '',}}
              validationSchema={loginSchema}
              onSubmit={(values)=>handleSubmit(values)}
              >
            {({ values,touched, errors,setFieldValue }) => (
              <Form>
                <div className="mt-5">
                  <PhoneInput
                    country={"sy"}
                    onlyCountries={["sy"]}
                    disableDropdown={true}
                    excludeCountries={['il']}
                    enableSearch={true}
                    value={values.phone}
                    onChange={(phone) => setFieldValue("phone", phone.startsWith("+") ? phone : `+${phone}`)}
                    inputStyle={{
                      borderRadius: "4px",
                      width: "100%",
                      height: "56px",
                      border: touched.phone && errors.phone ? "1px solid red" : "",
                    }}
                    buttonStyle={{ marginRight: "8px", direction: "ltr" }}
                    containerStyle={{
                      display: "flex",
                      flexDirection: i18n.language === "ar" ? "row-reverse" : undefined,
                    }}
                    inputProps={{
                      autoComplete: "phone",
                    }}
                  />
                  <div className="text-red-500 text-sm mt-1">
                    {touched.phone && errors.phone ? errors.phone : ""}
                  </div>
                  <Field
                    as={TextField}
                    name="password"
                    type={showPass ? "text" : "password"}
                    label={t("password")}
                    className="w-full !mt-5"
                    autoComplete="password"
                    helperText={touched.password && errors.password ? errors.password : ""}
                    error={touched.password && Boolean(errors.password)}
                    InputProps={{
                      endAdornment: (
                          <IconButton onClick={()=>setShowPass((prev)=>!prev)}>
                            {showPass ? <Visibility/> : <VisibilityOff/>}
                          </IconButton>
                      ),
                    }}
                  />
                </div>
                <DialogActions className={i18n.language === "en" ? "!justify-start" : "!justify-start"}>
                  <Button className='w-full h-[62px] !bg-customerColor !text-white !rounded-full' type="submit">
                    {loginLoading 
                    ? <CircularProgress className='w-1 h-1'/>
                    :t("confirm")
                    }
                  </Button>
                </DialogActions>
              </Form>
            )}
              </Formik>
              <div className='flex justify-between flex-wrap'>
                <Button className='!text-[11px] !text-black !capitalize' onClick={handleOpenSignup}>
                  {t("signup")}
                </Button>
                <Button className='!text-[11px] !text-black !capitalize' onClick={handleForgetPassword}>
                  {t("forgot_password")}
                </Button>
              </div>
              </DialogContent>
            </div>
            <div className='flex flex-col items-center'>
              <div className='w-[3px] h-full bg-[#D9D9D9]'></div>
              <div className=''>{i18n.language === "en" ? "Or" : "أو"}</div>
              <div className='w-[3px] h-full bg-[#D9D9D9]'></div>
            </div>
            <div className='w-full'>
              <DialogTitle className='flex gap-3'>
                <p className="whitespace-pre-line">{t("download_from_app")}</p>
              </DialogTitle>
              <DialogContent>
                <DialogActions>
                  <Button className='w-full gap-2 h-[49px] !bg-[#EDEDED] !text-black !font-bold !rounded-full'>
                    <div>
                      <img src={apple} alt='no-photo'/>
                    </div>
                    <div>
                      {t("apple")}
                    </div>
                  </Button>
                </DialogActions>
                <DialogActions>
                  <Button className='w-full gap-2 h-[49px] !bg-[#EDEDED] !text-black !font-bold !rounded-full'>
                    <div>
                      <img src={google} alt='no-photo'/>
                    </div>
                    <div>
                      {t("google")}
                    </div>
                  </Button>
                </DialogActions>
              </DialogContent>
            </div>
          </div>
      </Dialog>
    </div>
  )
}

export default Login